import type { TenantById } from '@fitness-force/models';
import { createAction, emptyProps, props } from "@ngrx/store";

export const FETCHED_TENANT_LIST = createAction(
    'FETCHED_TENANT_LIST',
    emptyProps
);

export const FETCHED_TENANT_LIST_SUCCESS = createAction(
  'FETCHED_TENANT_LIST_SUCCESS',
  props<{ all_tenant:any}>()
);

export const SET_ACTIVE_TENANT = createAction(
  'SET_ACTIVE_TENANT',
  props<{selected_tenant:any }>()
);

export const SET_ACTIVE_TENANT_SUCCESS = createAction(
  'SET_ACTIVE_TENANT_SUCCESS',
  props<{selected_tenant:any }>()
);

export const SET_ACCESSED_TENANT = createAction(
  'SET_ACCESSED_TENANT',
  props<{ all_tenant:any}>()
);

export const SET_ACCESSED_TENANT_SUCCESS= createAction(
  'SET_ACCESSED_TENANT_SUCCESS',
  props<{accessed_tenant: any}>()
);

export const FETCHED_TENANT_DETAILS = createAction(
    'FETCHEDTENANTDETAILS',
    props<{ selected_tenant: any }>()
);
export const FETCHED_TENANT_DETAIL_SUCCESS = createAction(
  'FETCHED_TENANT_DETAIL_SUCCESS',
  props<{ selected_tenant: any }>()
);

export const ERROR_TENANT_LIST = createAction(
    'ERRORTENANTLIST',
    props<{ err: Error }>()
);

export const FETCHED_TENANT_BY_ID = createAction(
    'FETCHEDTENANTBYID',
    emptyProps
);

export const FETCHED_TENANT_BY_ID_SUCCESS = createAction(
  'FETCHED_TENANT_BY_ID_SUCCESS',
  props<{ tenant: TenantById }>()
);


